import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { clsx as cx } from 'clsx';

import { EPlatform } from '../../types/platform';

import * as styles from './DownloadAppBanner.css';

interface IDownloadAppBannerProps {
  url: string;
  platformType: EPlatform;
  isRedesign?: boolean;
  onDownloadAppClick(): void;
  onMobileAppClick(): void;
}

export const DownloadAppBanner: React.FC<IDownloadAppBannerProps> = ({
  url,
  platformType,
  onDownloadAppClick,
  onMobileAppClick,
  isRedesign,
}) => {
  return (
    <div className={cx(styles['banner'], isRedesign && styles['banner--redesign'])} data-testid="DownloadAppBanner">
      <div className={styles['image']}></div>
      <span className={styles['download-text']}>Приложение быстрее и удобнее</span>
      <LinkButton
        fullWidth
        href={url}
        onClick={onDownloadAppClick}
        data-testid={`${platformType === EPlatform.Android ? 'DownloadLinkGooglePlay' : 'DownloadLinkAppStore'}`}
      >
        Скачать приложение
      </LinkButton>
      {!isRedesign && (
        <a
          href="/mobile-app/"
          target="_blank"
          data-testid="LinkToMobileApp"
          className={styles['link']}
          onClick={onMobileAppClick}
        >
          Подробнее
        </a>
      )}
    </div>
  );
};
